export function read(binaryFile) {
    const { type } = binaryFile;
    if (!type.startsWith( 'image/' ))
        return Promise.resolve( { binaryFile } );

    return new Promise( (resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = ( { target: { result } } ) => {
            binaryFile.content = result;

            const url = URL.createObjectURL( binaryFile );
            const img = new Image;
    
            img.onload = function() {
                resolve( { binaryFile, width: img.width, height: img.height } );
                URL.revokeObjectURL( img.src );
            };

            img.onerror = reject;
    
            img.src = url;
        };

        reader.onerror = reject;

        reader.readAsBinaryString( binaryFile );
    } );
}



// WEBPACK FOOTER //
// ./src/js/utils/file.js